import axios from 'axios';

const API_URL = process.env.REACT_APP_FRONT_API_URL;

export interface Faq {
  id: number;
  question: string;
  answer: string;
  category: string;
  display_order: number;
  created_at: string;
  updated_at: string;
}

export const faqService = {
  getAllFaqs: async (): Promise<Faq[]> => {
    const response = await axios.get(`${API_URL}/faq`);
    return response.data;
  },

  getFaqsByCategory: async (category: string): Promise<Faq[]> => {
    const response = await axios.get(`${API_URL}/faq/category/${category}`);
    return response.data;
  },

  createFaq: async (faq: Omit<Faq, 'id' | 'created_at' | 'updated_at'>): Promise<Faq> => {
    const response = await axios.post(`${API_URL}/faq`, faq);
    return response.data;
  },

  updateFaq: async (id: number, faq: Partial<Faq>): Promise<Faq> => {
    const response = await axios.put(`${API_URL}/faq/${id}`, faq);
    return response.data;
  },

  deleteFaq: async (id: number): Promise<void> => {
    await axios.delete(`${API_URL}/faq/${id}`);
  },
};
